import Reflux from 'reflux';
import { UserActions, AppActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const UserStore = Reflux.createStore({
  listenables: [UserActions],
  data: {
    list: [],
    selected: null,
    loading: true
  },

  getInitialState() {
    return this.data;
  },

  onFindReaders(
    showCourses = false,
    showCircles = false,
    sortBy = 'name',
    sortMode = 'asc'
  ) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.request('user', 'findReaders', {
      showCourses,
      showCircles,
      sortBy,
      sortMode
    }).then(
      response => {
        UserActions.findReadersComplete(response);
      },
      error => {
        this.data.loading = false;
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },

  onSelect(student) {
    this.data.selected = student;
    this.trigger(this.data);
  },

  onFindReadersComplete(data) {
    this.data.list = data;
    this.data.loading = false;
    this.trigger(this.data);
  },

  addToCircle(userId, circleId, callback) {
    return SteelCompass.call(
      'user',
      'addToCircle',
      { userId, circleId },
      () => {
        UserActions.addToCircleComplete(callback);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },

  addToCircleComplete(callback) {
    callback();
  },

  setCircleRole(userId, circleId, role) {
    return SteelCompass.call(
      'user',
      'setCircleRole',
      { userId, circleId, role },
      () => {
        UserActions.setCircleRoleComplete();
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  setCircleRoleComplete() {},

  listPwned() {
    return SteelCompass.call('user', 'listPwned', {}, response => {
      UserActions.listPwnedComplete(response.data);
    });
  },

  listPwnedComplete(data) {
    this.data.list = data;
    this.data.loading = false;
    this.trigger(this.data);
  },
  course(id, userId, expires) {
    return SteelCompass.call(
      'access',
      'course',
      { id, userId, expires },
      response => {
        UserActions.courseComplete();
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  courseComplete() {}
});

export default UserStore;



// WEBPACK FOOTER //
// ./src/js/stores/User.js